import React from 'react';
import { PureComponent } from '../../../dispatcher/modules';
import {
  RadioButton as KendoRadioButton
} from '@progress/kendo-react-inputs';
import classNames from 'classnames';
import WithTooltip from '../../../utility/withTooltip';
import _ from 'lodash';
import PuzzleTooltip from '../tooltip/PuzzleTooltip';
import Container from '../../layout/container/Container';
import { PUZZLE_RADIO_PROPS } from './Types';
import { TOOLTIP_OMITTED_PROPS } from '../../../utility';

/**
 * This component serves as extended version of Kendo's radio
 * @author Stevan Stojanovic
 **/
class PuzzleRadio extends PureComponent<PUZZLE_RADIO_PROPS, {}> {
  tooltip: any = null;

  static defaultProps = {
    tooltipOpenDelay: 1000,
    tooltipAnchor: 'target',
    'data-cy': 'radio'
  }

  render(): any {
    const {
      className = '',
      checked,
      withTooltip,
      titleText,
      tooltipContent,
      tooltipPosition,
      tooltipOpenDelay,
      tooltipAnchor,
      tooltipClassName = '',
      dataCy
    } = this.props;

    const radioClasses = classNames(
      `tp-radio-button ${className}`,
      {
        'qa-fakeClass-checked': checked
      }
    );

    const radioProps = _.omit(this.props, 'dataCy', TOOLTIP_OMITTED_PROPS);

    if (withTooltip) {
      return (
        <>
          <WithTooltip
            className={tooltipClassName}
            context={this}
            title={titleText}
            htmlTag={'span'}
          >
            <Container
              alignItemsCenter
              className={'tp-radio-wrapper'}
              displayInlineFlex
              dataCy={dataCy ? `${dataCy}-wrapper` : ''}
            >
              <KendoRadioButton
                {...radioProps}
                className={radioClasses}
                title={titleText}
              />
            </Container>
          </WithTooltip>
          <PuzzleTooltip
            anchorElement={tooltipAnchor}
            ref={(el: any) => this.tooltip = el}
            openDelay={tooltipOpenDelay}
            position={tooltipPosition}
            content={tooltipContent}
          />
        </>
      );
    }

    return (
      <Container
        alignItemsCenter
        className={'tp-radio-wrapper'}
        hBox
        dataCy={dataCy ? `${dataCy}-wrapper` : ''}
      >
        <KendoRadioButton
          {...radioProps}
          // <debug>
          data-cy={'radio'}
          // </debug>
          className={radioClasses}
        />
      </Container>
    );
  }
}

export default PuzzleRadio;
